class MassGiftForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector("button[type='submit']");
    this.error = this.querySelector(".error");
    this.success = this.querySelector(".success");
    if (this.error) this.error.style.display = "none";
    if (this.success) this.success.style.display = "none";
    if (this.form)
      this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
  }

  showError(text) {
    if (!this.error) return;
    this.error.style.display = "block";
    this.error.textContent = text;
    this.resetButton();
  }

  resetButton() {
    if (!this.submitButton) return;
    this.submitButton.innerHTML =
      this.submitButton.dataset.originalText || "Submit";
    this.submitButton.disabled = false;
  }

  getFormJSON() {
    const fd = new FormData(this.form);
    const data = {};
    fd.forEach((v, k) => (data[k] = typeof v === "string" ? v.trim() : v));
    return {
      firstName: data["first-name"] || "",
      lastName: data["last-name"] || "",
      email: data["emailOrPhone"] || data["email"] || "",
      phone: data["phone"] || "",
      company: data["company"] || "",
      targetDate: data["target-date"] || "",
      message: data["message"] || "",
    };
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    const payload = this.getFormJSON();
    if (!payload.email || !payload.email.includes("@")) {
      this.showError("Please enter a valid email address");
      return;
    }

    this.error?.style && (this.error.style.display = "none");
    this.success?.style && (this.success.style.display = "none");
    if (this.submitButton) {
      this.submitButton.dataset.originalText = this.submitButton.innerHTML;
      this.submitButton.innerHTML = "Submitting...";
      this.submitButton.disabled = true;
    }

    try {
      const resp = await fetch(
        "https://feno-co-tjjv.vercel.app/api/mass-gift",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(text || "Submission failed");
      }

      if (this.success) this.success.style.display = "block";
      this.resetButton();
      this.form.reset();
    } catch (err) {
      this.showError(err.message || "Something went wrong");
    }
  }
}

customElements.define("mass-gift-form", MassGiftForm);
